import { IBusiness } from '@/coreDomainsModule/entities/businessBase';
import { IUnmanagedBusiness } from '@/coreDomainsModule/entities/unmanagedBusiness';
import { convertLeadTimeToDays } from '@/coreDomainsModule/leadtime';
import { INetworkResult } from '@/coreDomainsModule/networkResult';
import {
  ExistsAggregateBusinessParameters,
  ExistsAggregateBusinessSuccessAllOfResult,
} from '@/coreInfrastructureModule/axios/generated/aggregateBusinessManage';
import { IAggregateBusinessRepository } from '@/coreInfrastructureModule/interfaces/IAggregateBusinessRepository';

/**
 * 集計取引が存在するかどうかを確認する
 */
export class CheckDuplicateAggregateBusinessUseCase {
  /**
   * コンストラクタ
   * @param repository - リポジトリ
   */
  constructor(private readonly repository: IAggregateBusinessRepository) {}

  /**
   * 集計取引が存在するかどうかを確認する
   * @param business - 取引情報
   */
  public async execute(
    business: IBusiness | IUnmanagedBusiness
  ): Promise<INetworkResult<ExistsAggregateBusinessSuccessAllOfResult, Error>> {
    try {
      const moq = 'moq' in business ? business.moq : business.MOQ;
      const parameters: ExistsAggregateBusinessParameters = {
        warehouseNumber: business.warehouseNumber,
        supplierNumber: business.supplierNumber,
        businessNumber: business.businessNumber,
        package: Number(business.package),
        unit: business.unit ?? '',
        leadTime: convertLeadTimeToDays(business.leadTime ?? 0, business.leadTimeUnit ?? ''),
        leadTimeUnit: business.leadTimeUnit ?? '',
        stdInventoryIndicesMin: business.stdInventoryIndices?.標準在庫指数.min ?? 0,
        stdInventoryIndicesMax: business.stdInventoryIndices?.標準在庫指数.max ?? 0,
        stdInventoryIndicesUnit: business.stdInventoryIndices?.標準在庫指数.option.unit ?? '',
        moq,
      };
      const result = await this.repository.checkDuplicateAggregateBusiness(parameters);

      if (result.status.type === 'error') {
        return {
          status: {
            type: 'error',
            error: Error('取引情報の作成に失敗しました'),
          },
        };
      }

      return {
        status: {
          type: 'success',
          data: result.status.data,
        },
      };
    } catch (error) {
      return {
        status: {
          type: 'error',
          error: Error('取引情報の作成に失敗しました'),
        },
      };
    }
  }
}
